export const getScrollDepth = () =>
  // This metric is crucial for getting factual user engagement
  //Capture once on unmount.
  // Time on page alone is misleading.
  // Someone leaving tab open ≠ engagement
  Math.round(
    ((window.scrollY + window.innerHeight) /
      document.documentElement.scrollHeight) *
      100,
  );

export const getOrCreateSessionId = () => {
  let id = sessionStorage.getItem("session_id");
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem("session_id", id);
  }
  return id;
};

export const getOrCreateVisitorId = () => {
  let id = localStorage.getItem("visitor_id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("visitor_id", id);
  }
  return id;
};
